
import { css } from 'lit';
export default css`
:host {
  display: flex;
  flex-direction: column;
  margin-top: 64px;
}

  @media (min-width: 768px) {:host {
    margin-top: 72px;
  }
  }@media (min-width: 768px) {

  :host {
    flex-direction: row;
  }
}@media (min-width: 1024px) {

  :host {
    margin-top: 0px;
  }
}
::slotted([slot='flag']) {
  margin-bottom: 1.5rem;
  flex-shrink: 0;
  font-weight: 900;
}
@media (min-width: 768px) {

  ::slotted([slot='flag']) {
    margin-bottom: 0px;
  }

  ::slotted([slot='alerts']) {
    flex-grow: 1;
  }
}
`;